/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Source_LanguageInputs */

const en_offline_sync_source_language = /** @type {(inputs: Offline_Sync_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source Language`)
};

const fr_offline_sync_source_language = /** @type {(inputs: Offline_Sync_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue source`)
};

const de_offline_sync_source_language = /** @type {(inputs: Offline_Sync_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quellsprache`)
};

const it_offline_sync_source_language = /** @type {(inputs: Offline_Sync_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingua di origine`)
};

const ru_offline_sync_source_language = /** @type {(inputs: Offline_Sync_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исходный язык`)
};

const es_offline_sync_source_language = /** @type {(inputs: Offline_Sync_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma de origen`)
};

const zh_cn2_offline_sync_source_language = /** @type {(inputs: Offline_Sync_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`源语言`)
};

const ja_offline_sync_source_language = /** @type {(inputs: Offline_Sync_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソース言語`)
};

const hi_offline_sync_source_language = /** @type {(inputs: Offline_Sync_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत भाषा`)
};

const pt_pt2_offline_sync_source_language = /** @type {(inputs: Offline_Sync_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma de origem`)
};

/**
* | output |
* | --- |
* | "Source Language" |
*
* @param {Offline_Sync_Source_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_source_language = /** @type {((inputs?: Offline_Sync_Source_LanguageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Source_LanguageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_source_language(inputs)
	if (locale === "de") return de_offline_sync_source_language(inputs)
	if (locale === "it") return it_offline_sync_source_language(inputs)
	if (locale === "ru") return ru_offline_sync_source_language(inputs)
	if (locale === "es") return es_offline_sync_source_language(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_source_language(inputs)
	if (locale === "ja") return ja_offline_sync_source_language(inputs)
	if (locale === "hi") return hi_offline_sync_source_language(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_source_language(inputs)
	return en_offline_sync_source_language(inputs)
});